// extracted by mini-css-extract-plugin
export default {"brandPromo":"IG-z","carousel":"JG-z"};